import { Injectable } from '@angular/core';

import { IProcessOrder } from '../../interfaces/IProcessOrder';
import { VIEW_TYPES } from '../../utils/constants';
import { FrontLoading } from '../view-types/frontLoading';
import { RearLoading } from '../view-types/rearLoading';
import { Retail } from '../view-types/retail';

@Injectable({
  providedIn: 'root',
})
export class OrderProcessingService {
  private processOrderConfig: IProcessOrder;

  wrongAssociateId = 'common.wrongAssociateId';

  constructor(
    private rearLoading: RearLoading,
    private frontLoading: FrontLoading,
    private retailService: Retail
  ) {}

  set orderToProcess(orderToProcess: IProcessOrder) {
    this.processOrderConfig = orderToProcess;
  }

  get orderToProcess(): IProcessOrder {
    return this.processOrderConfig;
  }

  processOrder(processOrder: IProcessOrder) {
    const viewType = processOrder.frodoContext;
    switch (viewType) {
      case VIEW_TYPES.REAR_LOADING:
        this.rearLoading.init(processOrder);
        break;
      case VIEW_TYPES.FRONT_LOADING:
        this.frontLoading.init(processOrder);
        break;
      case VIEW_TYPES.RETAIL:
        if (processOrder.initTransactionByCode) {
          this.retailService.validateCodeType(processOrder.code);
        } else {
          this.retailService.init(processOrder);
        }
        break;
    }
  }
}
